<template><bill-to-pay-editor ref="editor" mode="create" /></template>

<script>
import BillToPayEditor from '../../../../components/documents/BillToPayEditor.vue'

export default {
  name: 'create_document_bill_to_pay',
  components: { BillToPayEditor },
  beforeRouteLeave(to, from, next) {
    const editor = this.$refs.editor
    if (editor) editor.requestDirtyLeave(next)
    else next()
  }
}
</script>
